import React from 'react';
import { History } from 'history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faComments } from '@fortawesome/free-solid-svg-icons';

// The buttons to switch between the conversation view and the list view of the service desk
export const getTicketViewButtons = (history: History, currentView: 'chat' | 'list') => ({
    buttons: [
        { icon: <FontAwesomeIcon icon={faComments} />, label: 'ticket.general.chat_view_label', tabValue: 'chat' },
        { icon: <FontAwesomeIcon icon={faBars} />, label: 'ticket.general.list_view_label', tabValue: 'list' },
    ],
    currentView,
    buttonSize: 'small' as const,
    placement: 'end' as const,
    onViewChange: (view: string) => history.push(view === 'list' ? '/tickets/list' : '/tickets'),
});
